import { useRef, useEffect } from "react";
import { motion, useInView } from "framer-motion";
import { Instagram } from "lucide-react";

export const InstagramSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  // Load Elfsight script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup if needed
      const existingScript = document.querySelector('script[src="https://elfsightcdn.com/platform.js"]');
      if (existingScript) {
        // Keep the script as Elfsight manages its own lifecycle
      }
    };
  }, []);

  return (
    <section 
      ref={ref}
      className="py-24 md:py-40 px-6 md:px-12 bg-graphite-dark"
      data-testid="instagram-section"
    >
      <div className="max-w-screen-2xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
        >
          <div>
            <p className="font-body text-xs tracking-[0.3em] uppercase text-white/50 mb-4">
              Follow Along
            </p>
            <h2 
              className="font-heading text-4xl md:text-5xl font-bold tracking-tight uppercase text-white"
              data-testid="instagram-title"
            >
              @eliseredfield_
            </h2>
          </div>
          <a
            href="https://instagram.com/eliseredfield_"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary inline-flex items-center gap-3 w-fit"
            data-testid="instagram-follow-link"
          >
            <Instagram size={18} strokeWidth={1.5} />
            Follow on Instagram
          </a>
        </motion.div>

        {/* Elfsight Instagram Feed */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div 
            className="elfsight-app-f287b503-416f-489b-920a-25880755319e" 
            data-elfsight-app-lazy
          />
        </motion.div>
      </div>
    </section>
  );
};

export default InstagramSection;
